export default __webpack_public_path__ + "static/media/z010ma0c.0d7d3172.mp3";